import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { UtilsService } from 'src/app/@shared/services/utils/utils.service';
import { FROM, LEAVING_AT, LEAVING_IN, MINUTES, NOW, PLATFORM } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Departure } from 'src/app/modules/route-planner/interfaces/route-planning/departure.interface';
import { NextStopTime } from 'src/app/modules/route-planner/interfaces/route-planning/next-stop-times.interface';

@Component({
    selector: 'app-source-destination-results-list-item-stop-times',
    templateUrl: './source-destination-results-list-item-stop-times.component.html',
    styleUrls: ['./source-destination-results-list-item-stop-times.component.scss'],
    standalone: false
})
export class SourceDestinationResultsListItemStopTimesComponent implements OnInit, OnChanges {

  @Input() departureData: Departure
  @Input() isFutureSearch: boolean = false

  leavingInText: string
  leavingTimesText: string
  leavingStationDataText: string
  nowText: string
  isRealTime: boolean
  timeDiffs: number[] = [];

  constructor(private readonly languageService: LanguageService, private readonly utilsService: UtilsService) { }

  ngOnInit(): void {
    // this.getTimeDiffs(this.departureData.nextStopsTimes.slice(0, 3))
    this.initializeMultiLanguageTexts()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['departureData'] && !changes['departureData'].isFirstChange()) {
      // this.getTimeDiffs(this.departureData.nextStopsTimes.slice(0, 3));
    }
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.leavingInText = this.isFutureSearch ? LEAVING_AT[language.language] : LEAVING_IN[language.language]
      // this.leavingStationDataText = ` ${MINUTES[language.language]} ${FROM[language.language]}${this.departureData.place.name} - ${this.departureData.place.code}`
      this.leavingStationDataText = `${!this.isFutureSearch ? MINUTES[language.language] + ' ' : ''}${FROM[language.language]}${this.departureData.place.name} - ${this.departureData.place.code}`;
      if(this.departureData.place.platformNumber) {
        this.leavingStationDataText = `${this.leavingStationDataText} - ${PLATFORM[language.language]} ${this.departureData.place.platformNumber}`
      }
      this.nowText = NOW[language.language]
    })
  }

  getTimeDiffs(stopTime: NextStopTime) {
    if (stopTime.minutesToArrival < 1) {
      return this.nowText
    } else if (stopTime.minutesToArrival > 60) {
      return stopTime.arrivalTimeString
    }
    return Math.floor(stopTime.minutesToArrival);
  }
}
